import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loadCrmProfile } from '@crm/features/auth/crmAuthSlice';

export function BranchPickerPage() {
  const dispatch = useDispatch();
  const { branches, status, profile } = useSelector((s) => s.crmAuth);

  useEffect(() => {
    if (status === 'authenticated' && !profile) {
      dispatch(loadCrmProfile());
    }
  }, [dispatch, profile, status]);

  if (status === 'loading' || status === 'idle' || (status === 'authenticated' && !profile)) {
    return <div className="placeholder">Загрузка списка филиалов…</div>;
  }

  return (
    <section style={{ maxWidth: 560, margin: '40px auto' }}>
      <h1>Выберите филиал</h1>
      {branches.length === 0 && (
        <div className="placeholder">Вы не привязаны ни к одному филиалу.</div>
      )}
      <ul style={{ listStyle: 'none', padding: 0, display: 'grid', gap: 8 }}>
        {branches.map((b) => (
          <li key={b.id}>
            <Link
              to={`../${b.id}`}
              style={{
                display: 'block',
                padding: '14px 16px',
                background: '#fff',
                borderRadius: 'var(--radius-md)',
                boxShadow: 'var(--shadow-sm)',
              }}
            >
              {b.name}
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
